/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
const theme = {
  appearances: {
    compact: { type: 'variant', values: [ true ] },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    mini: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { expanded: true }, tokens: { icon: PaletteIconCaretUp } },
    {
      if: { compact: true },
      tokens: {
        paddingBottom: 8,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 8
      }
    },
    {
      if: { mini: true },
      tokens: { borderWidth: null, paddingBottom: 0, paddingTop: 0 }
    },
    {
      if: { focus: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#676e73',
        borderWidth: 1
      }
    },
    {
      if: { focus: true, mini: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#676e73',
        borderWidth: null
      }
    },
    {
      if: { hover: true },
      tokens: { backgroundColor: '#fafafa', iconPaddingTop: 8 }
    },
    {
      if: { expanded: true, hover: true },
      tokens: { backgroundColor: '#fafafa', iconPaddingTop: 0 }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#e3e6e8',
        borderColor: '#676e73',
        borderWidth: 1
      }
    },
    {
      if: { mini: true, pressed: true },
      tokens: {
        backgroundColor: '#e3e6e8',
        borderColor: '#676e73',
        borderWidth: null
      }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: 'rgba(0, 0, 0, 0)',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 1,
    icon: PaletteIconCaretDown,
    iconColor: '#2b8000',
    iconGap: 8,
    iconPaddingTop: 4,
    iconPosition: 'left',
    iconSize: 16,
    justifyContent: 'flex-start',
    paddingBottom: 16,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 16,
    textLine: 'none',
    verticalAlign: 'top'
  }
}
export default theme
